/**
project(box): yixinli-box
project(online): yixinli-box
sls-host(http): cn-hangzhou.sls.aliyuncs.com
sls-host(https): cn-hangzhou.log.aliyuncs.com
logstore:  frontend

curl --request GET 'http://${project}.${sls-host}/logstores/${logstore}/track?APIVersion=0.6.0&key1=val1&key2=val2'
其中：

${project} 是您在日志服务中开通的 project 名称。
${sls-host} 是您日志服务所在地区的域名。
${logstore} 是 ${project} 下面开通 tracking 功能的某一个 logstore 的名称。
APIVersion=0.6.0 是保留字段，必选。
key1=val1、key2=val2 是您要上传到日志服务的 key-value 对，可以有多个，但是要保证 url 的长度小于 16KB。 接口
=================================

from: log来源，产品名称、标识。

level： log级别
  -info: 反馈信息
  -quality: 质量
  -warn: 警告
  -error: 错误
  -fatal: 严重错误

### level:warn|error|fatal ###
error: 错误类型
  -api: 接口
  -api-data: 接口数据异常
  -js: js异常、错误

url: 当error为api/api-data，该值为对应api url。
msg: error信息，如由js error 对象引发，保存error messge即可。

### type:quality ###




[href]: 页面url

[remark]: 说明信息，由开发人员根据情况描述。

### error log ###
{
	from: "m",
	level: "info|warn|error|fatal",
	error: "js|api|api-data",
	url: "",
	msg: "",
	href: ""
}

### quality log ###
{
	from: "m",
	level: "quality",

}
=================================
 */

;(function(window) {
  var isLocalhost =
    document.location.host.indexOf('localhost') > -1 ? true : false
  if (!isLocalhost) {
    var host_split = document.location.host
    var debug = host_split.indexOf('box') > -1 || host_split.indexOf('qc') > -1
    console.log('is localhost')
  }
  var project = debug || isLocalhost ? 'yixinli-test' : 'yixinli'
  var stat_host =
    document.location.protocol.indexOf('https') < 0
      ? 'cn-hangzhou.sls.aliyuncs.com'
      : 'cn-hangzhou.log.aliyuncs.com'
  var stat_url =
    document.location.protocol +
    '//' +
    project +
    '.' +
    stat_host +
    '/logstores/frontend/track?APIVersion=0.6.0'

  var utils = {
    getScript: function(src, data) {
      if (!src) {
        return true
      }

      if (data) {
        var dataArr = [],
          val
        for (var i in data) {
          val = '' + data[i]
          val =
            val.indexOf('http') == 0 || val.indexOf('https') == 0
              ? encodeURIComponent(val)
              : val
          dataArr.push(i + '=' + val)
        }
        if (dataArr.length > 0) {
          src += (src.indexOf('?') > 0 ? '&' : '?') + dataArr.join('&')
        }
      }

      var script = document.createElement('script')
      script[this.scriptOnloadEvent] = script.onerror = function() {
        if (
          !script.readyState ||
          'loaded' === script.readyState ||
          'complete' === script.readyState
        ) {
          script[this.scriptOnloadEvent] = script.onerror = null
          script.parentNode.removeChild(script)
          script = null
        }
      }

      script.src = src

      var head = document.getElementsByTagName('head')[0]
      head.insertBefore(script, head.firstChild)
    }
  }

  var monitor = {
    globalData: {
      UA: navigator.userAgent
    },
    setGlobalData(data) {
      for (var key in data) {
        this.globalData[key] = data[key]
      }
    },
    // 历史方法，保留，避免报错
    setDefautData() {
      data = data || {}
      data.from = document.location.href
      data.href = document.location.href
      data.UA = navigator.userAgent
      return data
    },
    _getFinalData: function(data) {
      data = data || {}
      data.from = data.from || document.location.href
      data.href = data.href || document.location.href

      for (var key in this.globalData) {
        data[key] = this.globalData[key]
      }

      return data
    },
    stat: function(data) {
      data = this._getFinalData(data)
      utils.getScript(stat_url, data)
    }
  }

  window.onerror = function(message, source, lineno, colno, error) {
    // message：错误信息（字符串）。Available as event (sic!) in HTML onerror="" handler.
    // source：发生错误的脚本URL（字符串）
    // lineno：发生错误的行号（数字）
    // colno：发生错误的列号（数字）
    // error：Error对象（对象）
    monitor.stat({
      level: 'error',
      error: 'js',
      msg: message
    })
  }

  if (typeof module != 'undefined' && module.exports) {
    module.exports = monitor
  } else if (typeof define == 'function' && define.amd) {
    define(function() {
      return monitor
    })
  } else {
    window.monitor = monitor
  }
})(window)



// WEBPACK FOOTER //
// ./src/frontend-lib/lib/monitor.js